import { useMemo } from 'react';

export const enabledBoolOrListCheck = (switchValue, key) => {
  try {
    return (
      /\btrue\b|\ball\b/i.test(switchValue)
      || new RegExp('\\b' + key + '\\b').test(switchValue)
    )
  } catch (error) {
    return false
  }
}

export const useFeatureCheck = (feature, key = null) => {
  return useMemo(() => enabledBoolOrListCheck(
    feature,
    key
  ), [feature, key]);
};

export function getConfigLists() {
  const isSsr = typeof window === 'undefined';
  if (isSsr) return {};

  const {
    expConfiguration: {
      // ROPISstoreList
      storeList,

      // list or boolean features
      rentalDropoffEnabled,
      rentalDropoffDisabled,
      rentalEstimateEnabled,
      contractTermsEnabled,
      damageProtectionEnabled,
      rodfsEnabled,
      nucleusToolRentalCheckout,
      fdaV4Enabled,
      estimateGraphQlEnabled,
      pricingGraphQlEnabled,
      fulfillmentGraphQlEnabled,
      selfServiceGraphQlEnabled,
      reservationGraphQlEnabled,

      // itemId features
      itemIdBlacklist,
      rentalClearTools,
      deliveryOnlyItemIds,

      // Clear
      clearDefaultClientId,
      clearDefaultScope,
      clearEnvironment,
      clearRedirectUri
    },
  } = !isSsr && (window.__EXPERIENCE_PROPS__ || {});

  return {
    // ROPIS storeList
    whitelistedStores: storeList?.split(',') || [],

    // list or boolean features
    rentalDropoffEnabled,
    rentalDropoffDisabled,
    rentalEstimateEnabled,
    contractTermsEnabled,
    damageProtectionEnabled,
    fdaV4Enabled,
    estimateGraphQlEnabled,
    pricingGraphQlEnabled,
    fulfillmentGraphQlEnabled,
    selfServiceGraphQlEnabled,
    reservationGraphQlEnabled,
    nucleusToolRentalCheckout,
    rodfsEnabled,

    // itemId features
    blacklistedItems: itemIdBlacklist?.split(',') || [],
    rentalClearTools: rentalClearTools?.split(',') || [],
    deliveryOnlyItemIds: deliveryOnlyItemIds?.split(',') || [],

    // CLEAR
    clearDefaultClientId,
    clearDefaultScope,
    clearEnvironment,
    clearRedirectUri
  };
}
